export function NotFoundPage() {
  return (
    <div className="not-found">
      <p className="eyebrow">404</p>
      <h1>這顆小星暫時找不到</h1>
      <p>The page you’re looking for isn’t here.</p>
      <a className="outline-dark" href="/">
        BACK HOME
      </a>
    </div>
  );
}
